import { useEffect, useState } from 'react';
import useAuthorizationStore from 'src/hooks/useAuthorizationStore';
import useStoreDeep from 'src/hooks/useStore';
import getAlert, { GetAlertResponse } from '../requests/getAlert';
import { APIError, APIHookResponse, FetchAttr } from '../types';

interface GetAlertHookResponse extends APIHookResponse {
  getAlertRequest: () => Promise<GetAlertResponse>;
  data: GetAlertResponse;
}

const useGetAlert = (): GetAlertHookResponse => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<GetAlertResponse | null>(null);
  const [error, setError] = useState<APIError>(null);
  const userToken = useStoreDeep(
    useAuthorizationStore,
    (state) => state.userToken
  );

  const getAlertRequest = async (): Promise<GetAlertResponse> => {
    setIsLoading(true);
    if (userToken) {
      try {
        const attr: FetchAttr = {
          useCache: false,
          authRequired: true
        };

        const response = await getAlert(attr);
        setData(response);
        return response;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (userToken) {
      getAlertRequest();
    }
  }, [userToken]);

  return {
    getAlertRequest,
    isLoading,
    error,
    data
  };
};

export default useGetAlert;
